import { useList } from '../../../../../../../api/react-query';

export function useListNoticePeriodAutomationConfi(params = {}) {
  const {
    data,
    isLoading,
    error,
    refetch
  } = useList(
    'config/noticePeriod/auto',
    { ...params },
    '',
  )

  return {
    noticePeriodAutomationConfigs: data?.data?.data,
    count: data?.data?.totalCount,
    noticePeriodAutomationConfigsLoading: isLoading,
    noticePeriodAutomationConfigsError: error,
    refetch
  };
}
